import { faker } from '@faker-js/faker'

import { asBuilder } from '../asBuilder'
import { DuplicateRequest } from '../../contracts/service-offer/DuplicateRequest'

export const getAdminServiceOfferDuplicate = asBuilder((): DuplicateRequest => {
  return {
    source: {
      serviceOfferIds: faker.helpers.multiple(() => faker.number.int()),
    },
    destination: {
      hospitalIds: faker.helpers.multiple(() => faker.number.int()),
      payload: {
        serviceOfferStatus: faker.helpers.arrayElement(['NOT_APPROVED', 'APPROVED']),
      },
    },
  }
})
